import { Role } from 'src/@types/role';
import { useOrg } from 'src/hooks/query/orgHooks';
import { useUserRole } from 'src/hooks/useUserRole';
import TermsAcceptanceModal from './TermsAcceptanceModal';

export default function DtTermsGuard({ children }: { children: React.ReactNode }) {
  const { data: userRole } = useUserRole();
  const { data: currentOrg } = useOrg();

  const shouldShowModal =
    userRole !== Role.NuminarAdmin &&
    userRole !== Role.DTAdmin &&
    currentOrg &&
    currentOrg.managed_by_datatrust &&
    !currentOrg.user_accepted_dt_terms;

  return (
    <>
      {shouldShowModal && <TermsAcceptanceModal />}
      {children}
    </>
  );
}
